import AssetInfo from './AssetInfo';
import iconDark from '../../../../assets/icon_info_small.png';
import iconLight from '../../../../assets/icon_info_small_white.png';
import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';

export default {
	relativePath: 'info',
	label: {
		id: 'route.label.assets.detail.info',
		defaultValue: 'Info'
	},
	iconLight,
	iconDark,
	component: AssetInfo,
	requiredAuthorities: ['READ_DATAPOINT'],
	config: {
		sidebarIndex: 1
	}
} satisfies RouteConfig;
